import LogoSlogan from "@/assets/images/common/main_logo.png"
import LogoSimple from "@/assets/images/common/main_logo.png"
import SuccessImg from "@/assets/images/dashboard/success.webp"
import Marker from "@/assets/images/map/marker_not_selected.svg"
import MarkerSelected from "@/assets/images/map/marker.svg"
import MpassSmall from "@/assets/images/common/mpass_small.png"
import Rupor from "@/assets/images/common/rupor.webp"
import HandShake from "@/assets/images/common/hand_shake.webp"
import PromoSketch from "@/assets/images/common/promo_sketch.svg"
import HomeNoCredit from "@/assets/images/common/home_no_credit.webp"
import PinErr from "@/assets/images/common/pin_err.webp"
import Sunduc from "@/assets/images/common/sunduc.webp"
import DummyPdf from "@/assets/dummy_files/dummy.pdf"
import AppStore from "@/assets/images/app_markets/AppStore.png"
import AppGallery from "@/assets/images/app_markets/AppGallery.png"
import PlayStore from "@/assets/images/app_markets/PlayMarket.webp"
import TextlessLogo from "@/assets/images/common/logo_textless.png"
import SuccessApply from "@/assets/images/common/success_apply.webp"

class Images {

    static logos = {
        "LogoSlogan":LogoSlogan,
        "LogoSimple": LogoSimple,
        "Success": SuccessImg,
        "TextlessLogo": TextlessLogo
    }
    
    static map = {
        "MarkerSelected": MarkerSelected,
        "Marker": Marker
    }
    
    static common = {
        "mpass_small": MpassSmall,
        "rupor": Rupor,
        "hand_shake": HandShake,
        "promo_sketch": PromoSketch,
        "pin_err": PinErr,
        "home_no_credit": HomeNoCredit,
        "sunduc": Sunduc,
        "success_apply": SuccessApply
    }
    
    static dummyes = {
        "dummy_pdf": DummyPdf
    }
    
    static apps = {
        "PlayMarket": PlayStore,
        "AppGallery": AppGallery,
        "AppStore": AppStore,
    }

}

export default Images